module.exports = __webpack_public_path__ + "img/bg3.033e8645.svg";